// Zweck: Artikelangaben in beiden Lageransichten lesbar aufklappen. Stand: 22.10.2026.
import type { ReactNode } from 'react';
import { WarehouseIcon } from './WarehousePresentation';

export default function WarehouseArticleDetails({
  unit,
  codes,
  tracked,
  children,
}: {
  unit: string;
  codes: string[];
  tracked?: boolean;
  children?: ReactNode;
}) {
  return (
    <details className="wh-details">
      <summary>
        <WarehouseIcon kind="info" /> Artikeldetails
      </summary>
      <dl className="wh-metadata">
        <div>
          <dt>Einheit</dt>
          <dd>{unit}</dd>
        </div>
        <div>
          <dt>Erfassung</dt>
          <dd>
            {tracked ? 'Einzelne Geräte mit Seriennummer' : 'Mengen je Artikel'}
          </dd>
        </div>
        <div>
          <dt>Hinterlegte Codes</dt>
          <dd>{codes.length ? codes.join(', ') : 'Keine Codes hinterlegt'}</dd>
        </div>
      </dl>
      <p className="wh-field-hint">
        Artikelstammdaten werden aus HERO übernommen.
      </p>
      {children}
    </details>
  );
}
